// extracted by mini-css-extract-plugin
export var externalLink = "_9v-0";
export var internalLinkLabel = "_9v-1";